import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import moment from 'moment'
export default {
  props: {
    title: String,
    serviceOrderId: Number,
    service: Object,
    disabled: Boolean,
  },

  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))

    if (this.service) {
      this.currentService = this.service
      this.startStepDateTime = this.service.dateTimeStartStep
      this.endStepDateTime = this.service.dateTimeEndStep

      this.currentService.status =
        this.statusStep[this.service.statusStepServiceOrder]
      this.user = this.service.userResponsible
      this.isEditing = true
    }

    this.userName =
      this.user.name != undefined ? this.user.name : this.userLogged.name
  },

  data: () => ({
    step: 0,
    selectedStartTab: 0,
    selectedEndTab: 0,
    errorMessage: '',
    isEditing: false,
    loading: false,
    firstValid: false,
    error: false,
    dialog: false,
    startStepDateTimeError: false,
    userName: null,
    startStepDateTime: null,
    endStepDateTime: null,
    userLogged: {},
    user: {},
    currentService: {
      id: 0,
      description: '',
      dateTimeStartStep: null,
      dateTimeEndStep: null,
      timeSpent: null,
      status: null,
    },
    statusStep: [
      'Manutenção terceirizada in loco',
      'Manutenção terceirizada externa',
      'Manutenção interna',
      'Aguardando peça',
      'Aguardando orçamento',
      'Aguardando avaliação externa',
      'Aguardando aprovação de orçamento',
      'Aguardando liberação do setor',
      'Deslocamento',
      'Equipamento não encontrado',
    ],
    timeRules: [(v) => v == null || /^\d\d:\d\d/.test(v) || 'Tempo inválido'],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    validateDates() {
      if (
        !!this.startStepDateTime &&
        !!this.endStepDateTime &&
        moment(this.startStepDateTime).isAfter(moment(this.endStepDateTime))
      ) {
        this.$toast.warning(
          'A data de fim não pode ser antes da data de início'
        )
        return false
      }
      return true
    },

    async next() {
      if (this.step === 0) {
        if (
          this.$refs.firstForm.validate() &&
          this.startStepDateTime &&
          this.validateDates()
        ) {
          this.submit()
        } else {
          this.startStepDateTimeError = true
        }
      } else {
        this.close()
      }
    },

    setStartStepNowDate() {
      this.startStepDateTime = !this.startStepDateTime
        ? new Date()
        : this.startStepDateTime
    },

    setEndStepNowDate() {
      this.endStepDateTime = !this.endStepDateTime
        ? new Date()
        : this.endStepDateTime
    },

    async submit() {
      this.loading = true

      const userId =
        this.userLogged.id != this.user.id ? this.userLogged.id : this.user.id

      const service = {
        Id: this.currentService.id,
        UserResponsibleId: userId,
        Description: this.currentService.description,
        DateTimeStartStep: Utils.nowDatetimeFormat(this.startStepDateTime),
        DateTimeEndStep: Utils.nowDatetimeFormat(this.endStepDateTime),
        TimeSpent: this.currentService.timeSpent,
        StatusStepServiceOrder: this.statusStep.indexOf(
          this.currentService.status
        ),
        ServiceOrderId: this.serviceOrderId,
      }

      service.DateTimeEndStep == 'Invalid date'
        ? (service.DateTimeEndStep = null)
        : ''

      let url = 'service/add'

      if (this.isEditing) {
        url = 'service/edit'
      }

      await this.apiService
        .post(url, service)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    startStepDateTime: {
      deep: true,
      handler() {
        this.startStepDateTimeError = false
      },
    },
  },
}
